import { render, staticRenderFns } from "./measure.vue?vue&type=template&id=4c1404f8&scoped=true&lang=pug&"
import script from "./measure.vue?vue&type=script&lang=js&"
export * from "./measure.vue?vue&type=script&lang=js&"
import style0 from "./measure.vue?vue&type=style&index=0&id=4c1404f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1404f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c1404f8', component.options)
    } else {
      api.reload('4c1404f8', component.options)
    }
    module.hot.accept("./measure.vue?vue&type=template&id=4c1404f8&scoped=true&lang=pug&", function () {
      api.rerender('4c1404f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/floating_editor/measure/measure.vue"
export default component.exports